import revive_payload_client_4sVQNw7RlN from "/home/dolphgame/public_html/dolph_front_new/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/dolphgame/public_html/dolph_front_new/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/dolphgame/public_html/dolph_front_new/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/dolphgame/public_html/dolph_front_new/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/dolphgame/public_html/dolph_front_new/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/dolphgame/public_html/dolph_front_new/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/dolphgame/public_html/dolph_front_new/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/dolphgame/public_html/dolph_front_new/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/home/dolphgame/public_html/dolph_front_new/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import axios_QMFgzss1s4 from "/home/dolphgame/public_html/dolph_front_new/plugins/axios.ts";
import fav_tqGM4vjYFr from "/home/dolphgame/public_html/dolph_front_new/plugins/fav.ts";
import maska_UHaKf2z1iQ from "/home/dolphgame/public_html/dolph_front_new/plugins/maska.ts";
import mode_U2HMmIapxd from "/home/dolphgame/public_html/dolph_front_new/plugins/mode.ts";
import vue3_toastify_OGYNDsiW9E from "/home/dolphgame/public_html/dolph_front_new/plugins/vue3-toastify.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  axios_QMFgzss1s4,
  fav_tqGM4vjYFr,
  maska_UHaKf2z1iQ,
  mode_U2HMmIapxd,
  vue3_toastify_OGYNDsiW9E
]